import { Typography } from '@mui/material';
import { ChangeEvent, memo, MouseEvent, useCallback, useState } from 'react';
import DarkModeSwitch from 'src/layouts/components/panels/userprofile/components/DarkModeSwitch';

interface CustomToggleProps {
  fieldStyles: any;
  updateCallback: ((row: any, value: any) => Promise<boolean>) | undefined;
  row: any;
  col: any;
}

const CustomToggle = ({ fieldStyles, updateCallback, row, col }: CustomToggleProps) => {
  const [toggleDisabled, setToggleDisabled] = useState<boolean>(false);

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const handleToggleChange = useCallback(
    async (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setToggleDisabled(true);
      if (updateCallback !== undefined) {
        const res = await updateCallback(row, checked);
        if (res) {
          const newRow = { ...row };
          newRow[col.field] = checked;
        }
        await delay(1500);
        setToggleDisabled(false);
      }
    },
    [col.field, row, updateCallback]
  );

  // Prevents the grid from selecting the row when the toggle is clicked.
  const stopRowSelection = useCallback((event: MouseEvent) => event.stopPropagation(), []);

  return (
    <>
      <Typography
        noWrap
        component="a"
        variant="body2"
        sx={{ ...fieldStyles, ml: '10px', alignContent: 'center' }}
        onClick={stopRowSelection}
        onMouseDown={stopRowSelection}>
        <DarkModeSwitch
          name="toggle"
          checked={row[col.field]}
          disabled={toggleDisabled}
          onChange={handleToggleChange}></DarkModeSwitch>
      </Typography>
    </>
  );
};

export default memo(CustomToggle);
